/**
 * Order of the steps in the array is important, as they go one by one.
 *
 * nextStepSwitch: if we need to switch the step with the click on 'Got it' button.
 * hideCards: if we need to hide the cards until user navigates to the another page or performs a certain action.
 * showOnRoute: route name, we need this in order not to show cards if user clicks on other page while in progress of
 * a step.
 * isFixed: fixed position on the page, used for menu items.
 *
 **/

export const STEPS_SETTINGS: {
  id: string
  step: number
  content: string
  buttonText?: string
  width: number
  offset: {
    top: number
    bottom: number
    left: number
    right: number
  }
  isFixed?: boolean
  nextStepSwitch?: boolean
  hideCards?: boolean
  finishOnboarding?: boolean
  showOnRoute?: string
}[] = [
  {
    id: 'order-sales-menu-section',
    step: 1,
    content: 'To set up order collection go to the <strong>Orders</strong> section',
    width: 330,
    offset: {
      left: 76,
      top: -42,
      bottom: 0,
      right: 0,
    },
    isFixed: true,
    hideCards: true,
  },
  {
    id: 'order-sales-collection-section',
    step: 1,
    content:
      'Use our WooCommerce and Shopify plugin directly if your shop is built on either of them. For all other systems you can use Sales pixel',
    width: 400,
    offset: {
      left: 30,
      top: -100,
      bottom: 0,
      right: 0,
    },
    nextStepSwitch: true,
    showOnRoute: 'orders',
  },
  {
    id: 'campaign-menu-section',
    step: 2,
    content: 'To create a campaign go to the <strong>Campaign</strong> section.',
    width: 270,
    offset: {
      left: 76,
      top: -42,
      bottom: 0,
      right: 0,
    },
    isFixed: true,
    hideCards: true,
  },
  {
    id: 'campaign-welcome-section',
    step: 2,
    content:
      'A welcome campaign allows you to make a positive first impression on new influencers.',
    width: 400,
    offset: {
      left: -460,
      top: 0,
      bottom: 0,
      right: 0,
    },
    showOnRoute: 'campaigns',
    hideCards: true,
  },
  {
    id: 'campaign-description-section',
    step: 2,
    content:
      'To attract more influencers, ensure your campaign features a captivating name, a compelling description, and an eye-catching image.',
    width: 336,
    offset: {
      left: 420,
      top: 20,
      bottom: 0,
      right: 0,
    },
    showOnRoute: 'campaign-creation',
  },
  {
    id: 'campaign-payment-section',
    step: 2,
    content:
      'Establishing a streamlined payment method is crucial to ensuring the effectiveness of your campaign.',
    width: 460,
    offset: {
      left: 350,
      top: 25,
      bottom: 0,
      right: 0,
    },
    showOnRoute: 'campaign-creation',
  },
  {
    id: 'campaign-time-section',
    step: 2,
    content:
      'You have the option to define start and end events for your campaign. E.g. you can automatically end your campaign when a certain click limit is reached.',
    width: 360,
    offset: {
      left: 360,
      top: 25,
      bottom: 0,
      right: 0,
    },
    showOnRoute: 'campaign-creation',
  },
  {
    id: 'campaign-audience-section',
    step: 2,
    content:
      'You can invite creators by Instagram username, email, specific tags, or invite all Metapic creators from your country. You can skip this step and add creators later.',
    width: 400,
    offset: {
      left: 360,
      top: 25,
      bottom: 0,
      right: 0,
    },
    showOnRoute: 'campaign-creation',
    hideCards: true,
  },
  {
    id: 'campaign-finish-section',
    step: 2,
    content: 'Congratulations, you completed step 2! Let’s go for the last step 3!',
    width: 340,
    offset: {
      left: 560,
      top: -50,
      bottom: 0,
      right: 0,
    },
    showOnRoute: 'campaign-users',
    nextStepSwitch: true,
  },
  {
    id: 'manage-campaign-menu-section',
    step: 3,
    content: 'To manage a campaign go to the <strong>Campaign</strong> section.',
    width: 270,
    offset: {
      left: 76,
      top: -42,
      bottom: 0,
      right: 0,
    },
    isFixed: true,
    hideCards: true,
  },
  {
    id: 'manage-campaign-start-section',
    step: 3,
    content:
      'Mouse over a campaign and click the Manage button to see the detail view of a campaign.',
    width: 400,
    offset: {
      left: 360,
      top: 25,
      bottom: 0,
      right: 0,
    },
    showOnRoute: 'campaigns',
  },
  {
    id: 'manage-campaign-track-progress-section',
    step: 3,
    content:
      'Use these lists to track your campaign progress. <br /> Remember, when inviting Instagram creators, reach out to them directly and provide the invite link.',
    width: 400,
    offset: {
      left: 360,
      top: 25,
      bottom: 0,
      right: 0,
    },
    showOnRoute: 'campaign-users',
  },
  {
    id: 'manage-campaign-invite-section',
    step: 3,
    content: 'Click here to invite more creators.',
    width: 260,
    offset: {
      left: -278,
      top: -25,
      bottom: 0,
      right: 0,
    },
    showOnRoute: 'campaign-users',
    hideCards: true,
  },
  {
    id: 'manage-campaign-invite-creators-section',
    step: 3,
    content: 'You can invite creators to this campaign via email, tags, or the invite link.',
    width: 400,
    offset: {
      left: 380,
      top: 120,
      bottom: 0,
      right: 0,
    },
    showOnRoute: 'campaign-users',
    hideCards: true,
  },
  {
    id: 'manage-campaign-finish',
    step: 3,
    content: 'Congratulations! You completed the last step!',
    width: 400,
    offset: {
      left: 360,
      top: 25,
      bottom: 0,
      right: 0,
    },
    showOnRoute: 'campaign-users',
    finishOnboarding: true,
  },
]
